import { render, staticRenderFns } from "./ActivityConfigDialog.vue?vue&type=template&id=489ed9d4&scoped=true"
import script from "./ActivityConfigDialog.vue?vue&type=script&lang=js"
export * from "./ActivityConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigDialog.vue?vue&type=style&index=0&id=489ed9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ed9d4",
  null
  
)

export default component.exports